import { MenuItem, Typography, Select, Hidden } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useLingui } from "@lingui/react";
import { makeStyles } from "@material-ui/core/styles";
import { Trans, t } from "@lingui/macro";
import React from "react";
import { getBaseLocale, LOCALES } from "../../utils";
// theme
import theme from "../../theme";

const useStyles = makeStyles((theme) => ({
  selectBox: {
    padding: 0,
    marginRight: theme.spacing(2),
    "& > div.MuiSelect-root": {
      padding: 10,
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: "50%",
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
  },
  authenticatedSelectBox: {
    padding: 0,
    marginRight: theme.spacing(2),
    "& > div.MuiSelect-root": {
      padding: 10,
      border: `1px solid ${theme.palette.white}`,
      borderRadius: "50%",
      fontWeight: 600,
      color: theme.palette.white,
    },
  },
  selectBoxMobile: {
    paddingTop: 0,
    "& > div.MuiSelect-root": {
      paddingTop: 0,
      paddingBottom: 0,
      fontSize: 11,
    },
  },
  container: {
    textTransform: "capitalize",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

export default ({ isAdmin, isAuthenticated, currentLocale, onChangeLocale }) => {
  const { i18n } = useLingui();

  const classes = useStyles(theme);

  return (
    <Typography variant="body1" component="div" className={classes.container}>
      <Hidden mdUp>
        <Select
          value={currentLocale}
          onChange={onChangeLocale}
          className={classes.selectBoxMobile}
          IconComponent={ExpandMoreIcon}
          fullWidth
          native
        >
          {Object.keys(LOCALES).map((l) => (
            <option key={l} value={l} className={classes.capitalize}>
              {i18n._(t`${LOCALES[l]}`)}
            </option>
          ))}
        </Select>
      </Hidden>
      <Hidden smDown>
        <Select
          value={currentLocale}
          renderValue={(v) => getBaseLocale(v)}
          onChange={onChangeLocale}
          className={isAuthenticated && isAdmin ? classes.authenticatedSelectBox : classes.selectBox}
          IconComponent={() => <></>}
        >
          {Object.keys(LOCALES).map((l) => (
            <MenuItem key={l} value={l} className={classes.capitalize}>
              <Trans id={LOCALES[l]} />
            </MenuItem>
          ))}
        </Select>
      </Hidden>
    </Typography>
  );
};
